import {
  AuthRouteContext,
  type CanRedirectToUrl,
  useCurrentUser,
} from '@cosuno/authentication-frontend';
import React, { type PropsWithChildren, useMemo } from 'react';
import { matchRoutes } from 'react-router-dom';

import { USER_TYPE } from '~/__gql__/graphql';

import { checkIfRouteIsAllowed } from './AuthHandler';
import type { ExtendedRouteObject } from './types';

type Props = PropsWithChildren<{
  routes: ExtendedRouteObject[];
}>;

const CanRedirectToUrlProvider: React.FC<Props> = ({ children, routes }) => {
  const user = useCurrentUser();
  const isAdmin = user?.type === USER_TYPE.administrator;

  const ctxValue = useMemo<{ canRedirectToUrl: CanRedirectToUrl }>(
    () => ({
      canRedirectToUrl: ({ isUserAgent, isUserAnonymous, isUserPrincipal, redirect }) => {
        const match = matchRoutes(routes, redirect);
        // render 404 normally
        if (!match) return true;

        return checkIfRouteIsAllowed(
          match.map(({ route }) => route),
          {
            isUserAgent,
            isUserAnonymous,
            isUserPrincipal,
          },
          { isAdmin },
        );
      },
    }),
    [isAdmin, routes],
  );

  return <AuthRouteContext.Provider value={ctxValue}>{children}</AuthRouteContext.Provider>;
};

export default CanRedirectToUrlProvider;
